import { loadTossPayments } from '@tosspayments/tosspayments-sdk';

/** 결제 UI variantKey — 결제 어드민의 기본 결제 UI(설계 §4-1). */
export const PAYMENT_METHODS_VARIANT_KEY = 'DEFAULT';

export interface PaymentRequest {
  /** 토스 orderId = payments.id. */
  readonly orderId: string;
  readonly orderName: string;
  readonly successUrl: string;
  readonly failUrl: string;
}

/** 토스 주문서형 결제위젯을 우리 화면이 쓰는 최소 표면으로 감싼다 — SDK 타입이 상위 계층에 새지 않게 한다. */
export interface PaymentWidgets {
  readonly setAmount: (amount: number) => Promise<void>;
  readonly render: (selectors: {
    readonly paymentMethods: string;
    readonly agreement: string;
  }) => Promise<void>;
  /** 토스 결제창을 연다. 성공·실패하면 해당 주소로 이동하고, 창을 닫으면 오류로 거부된다. */
  readonly requestPayment: (request: PaymentRequest) => Promise<void>;
}

/** 토스 SDK 를 불러와 회원(customerKey)의 주문서형 결제위젯을 만든다(결제 설계 §11). */
export const loadPaymentWidgets = async (
  clientKey: string,
  customerKey: string,
): Promise<PaymentWidgets> => {
  const tossPayments = await loadTossPayments(clientKey);
  const widgets = tossPayments.widgets({ customerKey });

  return {
    setAmount: (amount) => widgets.setAmount({ currency: 'KRW', value: amount }),
    render: async ({ paymentMethods, agreement }) => {
      await Promise.all([
        widgets.renderPaymentMethods({
          selector: paymentMethods,
          variantKey: PAYMENT_METHODS_VARIANT_KEY,
        }),
        // 약관 UI 는 variantKey 를 넘기지 않아 상점 기본 약관 UI 를 쓴다 — 기본 키 이름이 결제 UI(DEFAULT)와 다르다.
        widgets.renderAgreement({ selector: agreement }),
      ]);
    },
    requestPayment: async (request) => {
      await widgets.requestPayment(request);
    },
  };
};
